import { Banner } from '@leoradating/ui';
import { useNotice } from './notice-context';

export { NoticeProvider, useNotice } from './notice-context';
export type { Notice } from './notice-context';

export const NoticeBanner = () => {
  const { notice } = useNotice();

  if (!notice) {
    return null;
  }

  return <Banner title={notice.title} body={notice.body} />;
};
